import React, { useState } from 'react'
import AcceptForm from './components/AcceptForm'
import Sidebar from '../Booking/components/Sidebar'
import { useSelector } from 'react-redux'

const AcceptModification = () => {
  const { dictionary } = window.modifyData
  const { type } = useSelector((state) => state.booking)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div className="page-container s-modify-reservation">
      <h1 className="h1 m-0">
        {type === 'modify'
          ? dictionary.acceptModificationHeading
          : dictionary.acceptCancelationHeading}
      </h1>
      <div className="row">
        <div className="col-lg-7">
          <AcceptForm type={type} onLoadingChange={setIsLoading} />
        </div>
        <div className="col-lg-4 offset-lg-1 d-none d-lg-block">
          <Sidebar isLoading={isLoading} />
        </div>
      </div>
    </div>
  )
}

export default AcceptModification
